import get from 'lodash.get';

export const PREVIEW_DISABLE_CLASS = 'vilynx_disabled';

export const RECO_CONFIG_HASH = {
  // Domain/vertical based configs
  news: {
    article: '79589c0f2796c6f6461b37a86172aacf',
    video: '54a80282f370926594f6b176836fc2fc',
  },
  today: {
    article: '0a3e7f4e49995181b036ad247404e31e',
    video: 'e23b39e864af49c0d3c3ac66fc835606',
  },
  msnbc: {
    article: '2aec508eb104c41752c74a8f8d7869ec',
    video: '6f4ceaabe4f31e691f0e6d89fe155533',
  },
  // Taxonomy based configs
  taxonomy: {
    nctx21956: 'ca225daac1298c44cd7eb76fb185f6ed',
  },
  // Content based configs
  giftGuide: '5d09107a05134877a86ba548b223f99d',
  trending: '6414c15575eec8d63b523060a53f76ba',
  nbcNewsCommerce: '2db41add09f31e88778cb49b94c70ada',
  betterNewsCommerce: '70fe6d5b44078db2bd93c21a283ec91e',
};

export const getUnibrowData = (row) => {
  let unibrow = null;
  if (row.unibrow && Array.isArray(row.unibrow) && row.unibrow.length) {
    unibrow = {
      text: row.unibrow[0],
      url: {
        primary: row.unibrow_url[0],
      },
    };
  }
  return unibrow;
};

export const getConfigurationHash = ({
  taxonomy,
  type = 'article',
  vertical,
}) => {
  // Specific configuration
  if (typeof RECO_CONFIG_HASH[type] === 'string') {
    return RECO_CONFIG_HASH[type];
  }
  // Taxonomy configuration
  if (!!RECO_CONFIG_HASH.taxonomy && Array.isArray(taxonomy) && taxonomy.length) {
    const taxonomyKey = Object.keys(RECO_CONFIG_HASH.taxonomy)
      .filter((key) => taxonomy.includes(key))
      .shift();
    if (taxonomyKey) {
      return RECO_CONFIG_HASH.taxonomy[taxonomyKey];
    }
  }
  // Vertical configuration
  if (typeof RECO_CONFIG_HASH[vertical] === 'object' && typeof RECO_CONFIG_HASH[vertical][type] !== 'undefined') {
    return RECO_CONFIG_HASH[vertical][type];
  }
  // Default
  return RECO_CONFIG_HASH.news.article;
};

export default function recommendationOptions({
  options: optionOverrides,
  taxonomy,
  type = 'video',
  vertical,
}) {
  const regex = /^.*-([0-9]+)$/;

  const filter = (row) => regex.test(row.url);

  const map = (row) => ({
    mpxMetadata: {
      id: row.url.replace(regex, '$1'),
    },
    url: {
      primary: row.url,
    },
    headline: {
      tease: row.title,
    },
    primaryImage: {
      url: {
        primary: `https://${row.thumbnail}`,
      },
    },
    duration: `PT${parseInt(row.duration, 10)}S`,
  });

  const defaultOptions = {
    callbacks: {
      filter,
      map,
    },
    confighash: getConfigurationHash({ taxonomy, type, vertical }),
    limit: 25,
    returnmetadata: true,
  };

  return { ...defaultOptions, ...optionOverrides };
}

export const showSourceMap = {
  news: {
    'meet-the-press': [
      'Meet the Press',
      'Meet the Press Original',
    ],
    'nightly-news': [
      'Nightly News',
      'Nightly News Netcast',
    ],
    dateline: [
      'Dateline',
      'Dateline Digital',
    ],
  },

  today: {
    'on-the-show': 'TODAY',
    originals: 'TODAY Originals',
    'sunday-today': 'Sunday TODAY',
    'weekend-today': 'Weekend TODAY',
  },

  msnbc: {
    'morning-joe': [
      'Morning Joe',
      'Morning Joe First Look',
    ],
    'velshi-ruhle': [
      'Ali Velshi',
      'Velshi & Ruhle',
    ],
    'andrea-mitchell': 'Andrea Mitchell Reports',
    'deadline-white-house': 'Deadline White House',
    'msnbc-live-ari-melber': 'The Beat with Ari Melber',
    hardball: 'Hardball',
    all: [
      'All In with Chris Hayes',
      'All In',
    ],
    'rachel-maddow-show': 'Rachel Maddow',
    'the-last-word': 'The Last Word',
    '11th-hour-with-brian-williams': 'Brian Williams',
    originals: 'MSNBC Originals',
    'your-business': 'Your Business',
    politicsnation: 'PoliticsNation',
    'am-joy': 'AM Joy',
    'kasie-dc': 'Kasie DC',
    'mtp-daily': 'MTP Daily',
  },
};

/**
 * Check 'folder' from document.referrer against configured list of
 * shows and fronts to determine if the associatedPlaylist should be displayed.
 * @param {string} vertical
 * @param {string} source
 */
export function showAssociatedFromReferrer(vertical, source) {
  if (vertical && source && document && document.referrer) {
    const referrerPath = document.referrer.replace(/^.*\/\/[^\\/]+\//, '');
    const mappedSource = get(showSourceMap, `${vertical}.${referrerPath}`, false);
    // Checked mapped source against given source
    if (mappedSource && (
      (typeof mappedSource === 'string' && mappedSource === source)
      || (typeof mappedSource === 'object' && mappedSource.includes(source))
    )) {
      return true;
    }
  }
  return false;
}

/**
 * Check if vertical configured to show the associatedPlaylist.
 * @param {string} vertical
 */
export function showAssociatedOnVertical(vertical) {
  return vertical && [
    'globalcitizen',
    'knowyourvalue',
  ].includes(vertical);
}
